import React, { useEffect, useState, useCallback } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import "../../profile.css";
import service from "../../services/service";
import endpoints from "../../services/endpoints";

const AddDistance = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [distance, setDistance] = useState("");
  const [unit, setUnit] = useState("Km");
  const [note, setNote] = useState("");

  const [displayText, setDisplayText] = useState("0 KM (0%)");
  const [loading, setLoading] = useState(false);

  /* =========================
      GET DISTANCE COVERED
  ========================= */
  const getDistanceCovered = useCallback(async () => {
    if (!id) return;

    try {

      const response = await service.get(endpoints.distance.distanceCovered(id));
      const data = response?.data?.data;

      setDisplayText(data?.distanceCoveredInfo?.display || "0 KM (0%)");
      setDistance(data?.distanceCoveredInfo?.km?.toString() || "");
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch distance covered");
    }
  }, [id]);

  /* =========================
      ADD DISTANCE
  ========================= */
  const addDistanceCovered = async () => {
    try {
      if (!distance || Number(distance) <= 0) {
        toast.error("Please enter a valid distance");
        return;
      }

      setLoading(true);

      const enteredDistance = Number(distance);

      const payload = {
        userChallengeId: Number(id),
        distance: Number(enteredDistance.toFixed(2)),
        unit: unit === "Miles" ? "MILES" : "KM",
        note: note?.trim() || "Manual Entry",
      };

      console.log("Payload:", payload);

      const response = await service.post(
        endpoints.distance.addDistance,
        payload
      );

      toast.success(
        response?.data?.message || "Distance added successfully"
      );

      setNote("");
      setDistance("");

      // Fetch updated KM summary
      await getDistanceCovered();

    } catch (error) {
      console.log(error);

      toast.error(
        error?.response?.data?.message ||
        "Failed to add distance"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDistanceCovered();
  }, [getDistanceCovered]);

  return (
    <div className="add-distance-page">
      <div className="add-distance-header" onClick={() => navigate(-1)}>
        <ArrowLeft size={22} className="cursor" />
        <h2>Add Distance Covered</h2>
      </div>

      <div className="distance-summary">
        <h1>{displayText}</h1>
        <p>Distance Covered</p>
      </div>

      <div className="distance-form">
        <label>Add Distance</label>

        <div className="distance-input-wrap">
          <input
            type="number"
            min="0"
            step="0.01"
            value={distance}
            onChange={(e) => setDistance(e.target.value)}
            placeholder="Enter distance"
          />

          <select value={unit} onChange={(e) => setUnit(e.target.value)}>
            <option value="Km">KM</option>
            <option value="Miles">Miles</option>
          </select>
        </div>

        <label>Note</label>

        <textarea
          rows={6}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Enter note"
        />

        <button
          className="distance-save-btn"
          onClick={addDistanceCovered}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default AddDistance;